'use client';

import React from 'react';

// PC端表格数据
const pcTableRows = [
  ['France/ Belgique', '10-19 Jours', '5.95 €', '6-13 Jours', '16.95 €'],
  ['Canada/ Suisse/ Luxembourg', '10-19 Jours', '6.95 €', '6-13 Jours', '21.95 €'],
  ['États-Unis', '10-19 Jours', '6.95 €', '6-13 Jours', '21.95 €'],
  ['Autres régions européennes', 'Indisponible', '/', '6-13 Jours', '21.95 €'],
  [
    'Guadeloupe/Martinique/Réunion/Polynésie Française',
    'Indisponible',
    '/',
    '6-13 Jours',
    '29.95 €',
  ],
  ['Autres régions', 'Indisponible', '/', '6-13 Jours', '50.95 €'],
];

// PC端表格组件
const PCTable: React.FC = () => (
  <table className="w-full table-fixed border-separate border-spacing-0 border-collapse my-4 text-[14px] max-[959px]:text-[12px]">
    <colgroup>
      <col className="w-1/3 h-[60px]" />
      <col className="w-1/6 h-[60px]" />
      <col className="w-1/6 h-[60px]" />
      <col className="w-1/6 h-[60px]" />
      <col className="w-1/6 h-[60px]" />
    </colgroup>
    <thead>
      <tr>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2" />
        <th className="h-[60px] border border-[#acc9fe] text-center py-2" colSpan={2}>
          Expédition Standard
        </th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2" colSpan={2}>
          Business Express
        </th>
      </tr>
      <tr className="bg-[#d3e1fb]">
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">Pays/Région</th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">
          Délai de livraison estimé
        </th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">
          Frais d&apos;expédition
        </th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">
          Délai de livraison estimé
        </th>
        <th className="h-[60px] border border-[#acc9fe] text-center py-2">
          Frais Business Express
        </th>
      </tr>
    </thead>
    <tbody>
      {pcTableRows.map((row, i) => (
        <tr key={i}>
          {row.map((cell, j) => (
            <td key={j} className="h-[60px] border border-[#acc9fe] text-center py-2 break-words">
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

// 公共信息区块
const InfoSection: React.FC<{ isMobile?: boolean }> = ({ isMobile }) => (
  <>
    <h3
      className={
        isMobile
          ? 'text-[14px] font-bold mb-2 mt-6'
          : 'mt-[30px] text-[20px] font-bold font-sans max-[959px]:text-[14px] max-[959px]:mb-[10px]'
      }
      style={{ ...(isMobile && { fontFamily: 'bricolageGrotesqueBold' }) }}
    >
      Remarque:
    </h3>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      En raison de ces restrictions, nous ne pouvons pas accepter les commandes de l&apos;Iran, du
      Soudan, de la Syrie, de la Corée du Nord, de Hong Kong, de Taiwan, de l&apos;Ouzbékistan, de
      l&apos;Inde, de la Fédération de Russie, de Cuba, du Brésil, de la Guyane française et du
      Venezuela.
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Affecté par les influences majeures, le delais de livraison peut-être retardé en raison de la
      réduction des vols internationaux. Il est recommandé de choisir le Business Express
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Les frais d&apos;expédition standard et les frais de messagerie commerciale ne
      s&apos;appliquent qu&apos;à l&apos;expédition dans les 20 paires
    </p>
    <h3
      className={
        isMobile
          ? 'text-[14px] font-bold mb-2 mt-6'
          : 'mt-[30px] text-[20px] font-bold font-sans max-[959px]:text-[14px] max-[959px]:mb-[10px]'
      }
      style={{ ...(isMobile && { fontFamily: 'bricolageGrotesqueBold' }) }}
    >
      Livraison gratuite à partir de 69 € (FR/BE/CA/CH/LU/US)
    </h3>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      Livraison gratuite à partir de 69 € (FR/BE/CA/CH/LU/US)
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}
      La livraison gratuite est calculée avant les frais de port.
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}Limité à l&apos;expédition standard.
    </p>
    <p className="m-0 leading-[22px] text-[12px]">
      {!isMobile && <br />}Application automatique sans code de coupon.
    </p>
    <h3
      className={
        isMobile
          ? 'text-[14px] font-bold mb-2 mt-6'
          : 'mt-[30px] mb-[20px] text-[20px] font-bold font-sans max-[959px]:text-[14px] max-[959px]:mb-[10px]'
      }
      style={{ ...(isMobile && { fontFamily: 'bricolageGrotesqueBold' }) }}
    >
      Suivi
    </h3>
    <p className="m-0 leading-[22px] text-[12px]">
      Vous pouvez suivre votre colis directement avec votre adresse e-mail en utilisant
      l&apos;option de suivi.
    </p>
  </>
);

// 移动端表格数据
const mobileStandardRows = [
  ['France/ Belgique', '10-19 jours', '5.95 €'],
  ['Canada/ Suisse/ Luxembourg', '10-19 jours', '6.95 €'],
  ['États-Unis', '10-19 jours', '6.95 €'],
  ['Autres régions européennes', 'Indisponible', '/'],
  ['Guadeloupe/Martinique/Réunion/Polynésie Française', 'Indisponible', '/'],
  ['Autres régions', 'Indisponible', '/'],
];

const mobileExpressRows = [
  ['France/ Belgique', '6-13 jours', '16.95 €'],
  ['Canada/ Suisse/ Luxembourg', '6-13 jours', '21.95 €'],
  ['États-Unis', '6-13 jours', '21.95 €'],
  ['Autres régions européennes', '6-13 jours', '21.95 €'],
  ['Guadeloupe/Martinique/Réunion/Polynésie Française', '6-13 jours', '29.95 €'],
  ['Autres régions', '6-13 jours', '50.95 €'],
];

// 移动端表格组件
const MobileTable: React.FC<{
  title: string;
  head: string[];
  rows: string[][];
  style?: React.CSSProperties;
}> = ({ title, head, rows, style }) => (
  <table
    className="w-full table-fixed border-separate border-spacing-0 border-collapse my-4 text-[12px]"
    style={style}
  >
    <colgroup>
      <col className="w-1/3" />
      <col className="w-1/3" />
      <col className="w-1/3" />
    </colgroup>
    <tbody>
      <tr>
        <td className="border border-[#acc9fe] text-center py-2 font-bold" colSpan={3}>
          {title}
        </td>
      </tr>
      <tr className="bg-[#d3e1fb]">
        {head.map((h, i) => (
          <td key={i} className="border border-[#acc9fe] text-center py-2 font-bold">
            {h}
          </td>
        ))}
      </tr>
      {rows.map((row, i) => (
        <tr key={i}>
          {row.map((cell, j) => (
            <td key={j} className="border border-[#acc9fe] text-center py-2 break-words">
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

// 移动端子组件
const FRShippingTrackingMobile: React.FC = () => (
  <div className="w-full py-[5.333vw] px-[4.267vw] text-[12px] mb-10">
    <h1 className="text-center text-[24px] font-bold mb-2">
      <span>Expédition&nbsp;&amp;&nbsp;Suivi</span>
    </h1>
    <p className="m-0 leading-[22px]">
      Affecté par les influences majeures, le delais de livraison peut-être retardé en raison de la
      réduction des vols internationaux. Il est recommandé de choisir le Business Express et merci
      pour votre soutien et votre compréhension.
    </p>
    <div className="w-full">
      <MobileTable
        style={{ margin: '20px 0' }}
        title="Expédition Standard"
        head={['Pays/Région', 'Délai de livraison estimé', "Frais d'expédition"]}
        rows={mobileStandardRows}
      />
      <MobileTable
        style={{ marginBottom: '20px' }}
        title="Business Express"
        head={['Pays/Région', 'Délai de livraison estimé', 'Frais Business Express']}
        rows={mobileExpressRows}
      />
    </div>
    <InfoSection isMobile />
  </div>
);

// PC端子组件
const FRShippingTrackingPC: React.FC = () => (
  <div className="max-w-[1880px] px-[200px] my-[30px] mx-auto text-[14px] mb-[100px]">
    <h1 className="text-center text-[34px] font-bold font-sans max-[959px]:text-[24px]">
      <span>Expédition&nbsp;&amp;&nbsp;Suivi</span>
    </h1>
    <br />
    <p className="m-0 leading-[22px] text-[14px] max-[959px]:text-[12px]">
      Affecté par les influences majeures, le delais de livraison peut-être retardé en raison de la
      réduction des vols internationaux. Il est recommandé de choisir le Business Express et merci
      pour votre soutien et votre compréhension.
    </p>
    <div className="w-full overflow-x-auto mt-[20px]">
      <PCTable />
    </div>
    <InfoSection isMobile={false} />
  </div>
);

// 主组件
const FRShippingTrackingClient: React.FC<{ isMobile: boolean }> = ({ isMobile }) => {
  return isMobile ? <FRShippingTrackingMobile /> : <FRShippingTrackingPC />;
};

export default FRShippingTrackingClient;
